import { createContext } from "react";
export const devicecontext = createContext();
